import { render, staticRenderFns } from "./CourseFinder.vue?vue&type=template&id=bf98dff8&scoped=true"
import script from "./CourseFinder.vue?vue&type=script&lang=js"
export * from "./CourseFinder.vue?vue&type=script&lang=js"
import style0 from "./CourseFinder.vue?vue&type=style&index=0&id=bf98dff8&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./CourseFinder.vue?vue&type=style&index=2&id=bf98dff8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf98dff8",
  null
  
)

export default component.exports